import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  tipos_polizas: [],
  tipo_cuenta_contable: [],
  cuenta_contable: [],
  cuentas_contables: [],
  ejercicios: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};